import placesListModule from '../placesListModule';

function scrollBar(resources, utility) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    link(scope) {
      utility.buildScrollbar(resources.playersListSelector);
    }
  };
}

placesListModule.directive('scrollBar', scrollBar);

export default scrollBar;
